<template lang="pug">
login-form.login.line-height-none(
  ref='template',
  :userRole='userRole',
  :loginButtonEvent='loginButtonEvent',
  :moveLinkEvent='moveLinkEvent',
  :errorMessages='errorMessages'
)
  template(#loginTitle) 塾管理者ログイン
  template(#accountCodeLabel) ID
  template(#passwordLabel) PW
  template(#loginButtonLabel) ログイン
  template(#moveLinkText) 二次元コードでログインする場合はこちら
</template>

<script lang="ts">
import { Component, Mixins, Ref } from 'vue-property-decorator'
import LoginMethods from '@/mixins/LoginMethods'
import LoginForm from '@/components/templates/manager/LoginForm.vue'
import { UserRoles } from '@/const/UserRoles'

/**
 * 塾管理者・ログイン画面
 */
@Component({
  components: {
    LoginForm,
  },
})
export default class DebugHome extends Mixins(LoginMethods) {
  // テンプレートRef
  @Ref() template!: LoginForm

  // 塾管理者権限
  private userRole: UserRoles = UserRoles.ACADEMY

  // ログイン処理
  private async loginButtonEvent() {
    this.$loading.start()
    await this.academyLogin(this.template.accountCode, this.template.password)
    this.$loading.complete()
  }

  /**
   * ログイン後の遷移先ページをオーバーライド
   */
  public topPagePath(): string {
    return '/academy/study-management'
  }

  // 遷移リンク押下時のイベント
  private moveLinkEvent() {
    // QRコードログイン画面へ遷移
    this.$router.push({ name: 'AcademyQrLogin' })
  }
}
</script>
